/*
  PLEASE DON'T EDIT THIS FILE.
  IF YOU NEED ANY CHANGES,
  PLEASE CONTACT Brian Nicholls or Sergio Nader
*/

import MfButton from '@components/branded/MfButton'
import HandlePackageJsonVersion from '@components/general/HandlePackageJsonVersion'
import isObjectEmpty from '@components/general/isObjectEmpty'
// import ProtectRouteNew from '@components/general/ProtectedRouteNew'
// import { setMfError, clearMfError } from '@src/actions'
import { getCurrentAgencyId } from '@components/general/mfgrid/helpers/Utils'
import ProtectedRouteNew from '@components/general/ProtectedRouteNew'
import { store } from '@src/redux/storeConfig/store'
// import { titleToSnakeCase } from '@src/utility/Utils'
import ODataStore from 'devextreme/data/odata/store'
import { exportDataGrid } from 'devextreme/excel_exporter'
import { ButtonGroup } from 'devextreme-react/button-group'
import DataGrid, {
  Column,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  ColumnFixing,
  Editing,
  FilterRow,
  Form,
  HeaderFilter,
  Item,
  LoadPanel,
  // Lookup,
  MasterDetail,
  Pager,
  Paging,
  // Popup,
  Position,
  // RowDragging,
  Search,
  SearchPanel,
  Selection,
  StateStoring,
  // Texts,
  Toolbar
} from 'devextreme-react/data-grid'
import DropDownButton from 'devextreme-react/drop-down-button'
// import { Tooltip, ITooltipOptions } from 'devextreme-react/tooltip'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver'
import PropTypes from 'prop-types'
import { useRef, useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { dispatchSweetAlert } from '../../../actions'
import brandit_rails, { addAuthHeadersToRequestConfig } from '../../../api/brandit_rails'
import { REACT_APP_BACKEND_API_URL } from '../../../Constants'
import useMediaQuery from '../../../utility/hooks/useMediaQuery'
// import { Row } from 'reactstrap'
import { hasPermission } from '../Permissions'
import { _searchMode } from './MfGridInternalFunctions'
import 'devextreme-react/text-area'
import 'devextreme-react/check-box'

HandlePackageJsonVersion()

// function useViewportDimensions() {
//   const [dimensions, setDimensions] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight
//   })

//   useEffect(() => {
//     const handleResize = () => {
//       setDimensions({
//         width: window.innerWidth,
//         height: window.innerHeight
//       })
//     }

//     window.addEventListener('resize', handleResize)

//     return () => {
//       window.removeEventListener('resize', handleResize)
//     }
//   }, [])

//   return dimensions
// }

const MfGridFunctional = ({
  actionButtonsConfig = {},
  columnsConfig = {},
  dataConfig = {},
  // defaultPageSize = 10,
  editingConfig = {
    // editing: false,
    // editingOptions: {}
    // urlCrudButtons: []
    // hideDeleteButton: false
  },
  // exportButton = {},
  filterConfig = {},
  gridConfig = {},
  masterDetailConfig = {},
  noDataText = 'No Data',
  // onExporting, // in case we need a custom export
  pager = {
    allowedPageSizes: [5, 10, 25, 50, 100],
    displayMode: 'full',
    visible: true,
    showNavigationButtons: true,
    showInfo: true,
    showPageSizeSelector: true
  },
  rowConfig = {},
  selectionConfig = {},
  ...props
}) => {
  const currentAgencyId = getCurrentAgencyId()
  const isLargeDesktop = useMediaQuery('(min-width: 1440px)')
  const isDesktop = useMediaQuery('(min-width: 1280px)')
  // const isSmallWindow = useMediaQuery('(min-width: 630px)')

  const { dataKey, gridRef, gridUrl, showBorders, titleNoSpace } = gridConfig

  const insertAtPosition = (str, char, position) => {
    return str.slice(0, position) + char + str.slice(position)
  }
  let storageKey = gridConfig.storageKey
  storageKey = insertAtPosition(storageKey, currentAgencyId, 32)
  storageKey = insertAtPosition(storageKey, currentAgencyId, 16)

  const searchByColumnsStorageKey = `searchByColumns_|${storageKey}`
  const [processedButtonFilters, setProcessedButtonFilters] = useState([])
  const [hasInitialData, setHasInitialData] = useState(false)
  // const [isExpanded, setIsExpanded] = useState(false)

  const [hasData, setHasData] = useState(true)
  const urlParams = useRef({})

  const showIds = store.getState().admins.current_admin.show_ids
  const {
    filter,
    filterButtons,
    gridToRefresh,
    isFilterButtonsStackable, // not being used so far
    // isSearchResponsive, for future use
    headerFilter,
    needsRefresh,
    searchPanel,
    showFilterRow,
    // showFilterButtons,
    showOnlyClearAndExportBtns = false
  } = filterConfig

  // const [viewportWidth, setViewportWidth] = useState(window.innerWidth)

  const [searchByColumns, setSearchByColumns] = useState(_searchMode(showFilterRow, searchByColumnsStorageKey))

  const [filtersStatus, setFiltersStatus] = useState({
    hasActiveFilters: false,
    hasGlobalSearch: false,
    hasColumnFilters: false
  })

  const getDataGrid = useCallback(() => {
    return gridRef && gridRef.current !== null ? gridRef.current.instance : gridRef.current.instance
  }, [gridRef])

  const checkFiltersStatus = () => {
    const instance = getDataGrid() // gridRef.current.instance
    const hasActiveFilters = !!instance.getCombinedFilter()
    const hasGlobalSearch = !!instance.option('searchPanel.text')
    const hasColumnFilters = instance.option('columns').some(column => !!column.filterValue)

    setFiltersStatus({
      hasActiveFilters,
      hasGlobalSearch,
      hasColumnFilters
    })
  }

  const handleOptionChanged = e => {
    if (e.fullName.startsWith('columns') || e.fullName === 'searchPanel.text' || e.fullName === 'filterValue') {
      checkFiltersStatus()
    }
  }

  // useEffect(() => {
  //   if (gridRef.current) {
  //     checkFiltersStatus()
  //   }
  // }, [])

  const [showHeaderFilter, setShowHeaderFilter] = useState(searchByColumns)
  const [searchByColumnsLabel, setSearchByColumnsLabel] = useState('Search By Columns')
  const [showGlobalFilter, setShowGlobalFilter] = useState(!searchByColumns)
  const { rowSelectionMode, selectAllMode, selectedRowKeys, showCheckBoxesMode } = selectionConfig
  const dispatch = useDispatch()

  /* DEFAULT VALUES */

  const {
    actionButtons,
    actionButtonsMode,
    actionButtonDevMessage,
    createButton,
    buttonsWidth = 'auto',
    // disabled = false,
    firstButtonConfig,
    isValid,
    showActionButtons,
    showCreateButton,
    showFirstButton,
    showFirstButtonOnly
  } = actionButtonsConfig

  const { editing, editingOptions, urlCrudButtons, editingUrlCrudButtons, hideDeleteButton } = editingConfig

  // SN CHECK buttonsUrl

  const { idSortOrder, sqlFields, sqlAppendix, imageKeys = null } = dataConfig
  const {
    // dataRowRender,
    hoverStateEnabled = true,
    rowAlternationEnabled,
    rowHeight, // default 30pxrowHeight
    showRowContextMenu = true
  } = rowConfig

  const {
    actionColumnClass = 'devex-column-vertical-align',
    actionColumnFixed = true,
    actionColumnWidth,
    allowColumnReordering = true,
    allowColumnResizing = false,
    allowSorting,
    columnAutoWidth = true,
    columnHidingEnabled,
    columns,
    showColumnChooser = true,
    showExportButton = true,
    ellipsisId = `ellipsisId`
  } = columnsConfig

  const renderedButtonsRef = useRef(null)
  // const filterButtonsRef = useRef(null)
  renderedButtonsRef.current = []

  const getTableViewName = () => {
    // const url = getUrl()
    // const url = gridUrl
    const result = getValueAfterTable(gridUrl)
    return result || false
  }

  const getValueAfterTable = urlString => {
    const match = urlString.match(/[\?&]table=([^&#]*)/)
    const valueAfterTable = match ? match[1] : null
    return valueAfterTable || false
  }

  const optionButtons = () => {
    const result = [
      {
        hasPermission: true,
        icon: 'fa-regular fa-filter-circle-xmark ',
        id: 'clearFilters',
        name: 'Clear Filters',
        onClick: clearFilters,
        text: 'Clear Filters',
        type: 'normal',
        visible: true
      },
      {
        hasPermission: true,
        icon: 'fa-regular fa-arrows-from-line',
        id: 'expandAll',
        name: 'Expand All ',
        onClick: expandAll,
        text: 'Expand All',
        type: 'normal',
        visible: masterDetailConfig && masterDetailConfig.enabled ? true : false
      },
      {
        enabled: false,
        hasPermission: true,
        icon: 'fa-regular fa-arrows-to-line',
        id: 'collapseAll',
        name: 'Collapse All ',
        onClick: collapseAll,
        text: 'Collapse All',
        type: 'normal',
        visible: masterDetailConfig && masterDetailConfig.enabled ? true : false
      },
      {
        hasPermission: true,
        icon: 'fa-regular fa-magnifying-glass',
        id: 'searchByColumns',
        name: 'search By Column1s',
        onClick: onClickShowFilterRow,
        text: searchByColumnsLabel,
        type: 'normal',
        visible: true
      },
      {
        hasPermission: true,
        icon: 'fa-regular fa-table-columns',
        id: 'columnChooser',
        name: 'Column Chooser',
        onClick: showColumnChooserFunction,
        text: 'Column Chooser',
        type: 'normal',
        visible: showColumnChooser
      },
      {
        hasPermission: true,
        icon: 'fa-regular fa-file-xls',
        id: 'exportExcel',
        name: 'Export to Excel',
        onClick: onExportingClick,
        text: 'Export to Excel',
        type: 'normal',
        visible: showExportButton
      }
    ]
    return result
  }

  const clearFilters = () => {
    const dataGrid = getDataGrid()

    dataGrid.clearFilter()
    dataGrid.option('searchPanel.text', '')

    const storageKey = dataGrid.option('stateStoring').storageKey
    const state = JSON.parse(localStorage.getItem(storageKey) || '{}')

    if (state) {
      state.searchText = ''

      // also delete column filters, if any
      if (Array.isArray(state.columns)) {
        state.columns = state.columns.map(col => {
          if ('filterValue' in col) {
            delete col.filterValue
          }
          if ('filterValues' in col) {
            delete col.filterValues
          }
          return col
        })
      }

      localStorage.setItem(storageKey, JSON.stringify(state))
    }

    if (props.eventsConfig.onClearFilters) {
      props.eventsConfig.onClearFilters()
    }
  }

  const optionButtonsShowOnlyClearAndExport = () => {
    const result = [
      {
        hasPermission: true,
        icon: 'fa-regular fa-filter-circle-xmark ',
        id: 'clearFilters',
        name: 'Clear Filters',
        onClick: clearFilters,
        text: 'Clear Filters',
        type: 'normal',
        visible: true
      },
      {
        hasPermission: true,
        icon: 'fa-regular fa-file-xls',
        id: 'exportExcel',
        name: 'Export to Excel',
        onClick: onExportingClick,
        text: 'Export to Excel',
        type: 'normal',
        visible: showExportButton
      }
    ]
    return result
  }

  const removeWindowFunctions = useCallback(() => {
    window.onClickExtraButton01 = null
    window.onClickExtraButton02 = null
    window.onClickExtraButton03 = null
    window.onClickExtraButton04 = null
    window.onClickExtraButton05 = null
  }, [])

  useEffect(() => {
    const setFilterButtons = () => {
      if (filterButtons && !isObjectEmpty(filterButtons)) {
        const theseButtonFilters = filterButtons.buttons.filter(item => item.visible === true)
        const filteredButtonsWithoutVisible = theseButtonFilters.map(({ icon, text, type }) => ({ icon, text, type }))
        return filteredButtonsWithoutVisible
      }
    }
    // setIsExpanded(masterDetailConfig && masterDetailConfig.autoExpandAll ? masterDetailConfig.autoExpandAll : false)
    if (filterButtons) {
      setProcessedButtonFilters(setFilterButtons())
    }
    if (needsRefresh) {
      getDataGrid().refresh()
    }
  }, [filterButtons, needsRefresh, getDataGrid, gridToRefresh, masterDetailConfig, removeWindowFunctions])

  useEffect(() => removeWindowFunctions, [removeWindowFunctions])

  const createButtonInfo = buttonInfo => {
    // Check if we already have an array for this ID
    if (!renderedButtonsRef.current[buttonInfo.id]) {
      renderedButtonsRef.current[buttonInfo.id] = []
    }
    const existingButton = renderedButtonsRef.current[buttonInfo.id].find(btn => btn.name === buttonInfo.name)

    if (!existingButton) {
      renderedButtonsRef.current[buttonInfo.id].push(buttonInfo)
    }
  }

  // const renderTooltTip = text => {
  //   return <div>{text}</div>
  // }

  const base_url = REACT_APP_BACKEND_API_URL
  const url = `${base_url}${gridUrl}`

  let thisFilter = null
  let propsSqlAppendix = ''
  if (sqlAppendix && sqlAppendix.enabled === true) {
    propsSqlAppendix = sqlAppendix.appendix
  }

  const checkInitialData = useCallback(async () => {
    const store = new ODataStore({
      url,
      key: dataKey,
      beforeSend(request) {
        addAuthHeadersToRequestConfig(request)
        request.params.sql_appendix = propsSqlAppendix
        request.params.id_sort_order = idSortOrder
        request.params.$top = 10
        request.params.image_keys = imageKeys
      }
    })

    try {
      const result = await store.load()
      setHasInitialData(result.length > 0)
    } catch (err) {
      setHasInitialData(false)
    }
  }, [dataKey, idSortOrder, imageKeys, propsSqlAppendix, url])

  useEffect(() => {
    checkInitialData()
  }, [checkInitialData])

  const fixingTexts = {
    fix: 'Freeze',
    leftPosition: 'To the left',
    rightPosition: 'To the right',
    unfix: 'Unfreeze'
  }

  if (props && filter && !isObjectEmpty(filter)) {
    thisFilter = filter
  }

  const dataSourceOptions = useMemo(
    () => ({
      store: {
        type: 'odata',
        // version: 2,
        url,
        key: dataKey,
        beforeSend(request) {
          addAuthHeadersToRequestConfig(request)

          // request.params.current_client_id = client_id;
          request.params.sql_appendix = propsSqlAppendix
          request.params.id_sort_order = idSortOrder
          request.params.image_keys = imageKeys
          if (request.method === 'MERGE') {
            request.headers['X-HTTP-Method'] = request.method
            request.method = 'PATCH'
          }

          urlParams.current = request.params
        }
      },
      onLoadError: e => {
        if (e.httpStatus === 401) e.message = 'Missing or expired token - please sign in. '
      },
      sqlFields: sqlFields || [],
      filter: thisFilter,
      postProcess: data => {
        if (data.length === 0) setHasData(false)
        else setHasData(true)

        return data
      }
    }),
    [dataKey, idSortOrder, propsSqlAppendix, sqlFields, thisFilter, url]
  )

  const expandAll = () => {
    getDataGrid().expandAll(-1)
  }
  const collapseAll = () => {
    getDataGrid().collapseAll(-1)
  }

  const onClickButtonFilter = e => {
    if (props.eventsConfig.onClickButtonFilter) {
      props.eventsConfig.onClickButtonFilter(e)
    }
  }

  // const onClickDelete = e => {
  //   if (props.eventsConfig.onClickDelete) {
  //     props.eventsConfig.onClickDelete(e)
  //   }
  // }

  // const clearFilterHandler = () => {
  //   if (gridRef.current) {
  //     const { instance } = gridRef.current

  //     instance.clearFilter()
  //     instance.option('searchPanel.text', '')
  //   }
  // }

  const onClickShowFilterRow = () => {
    const searchMode = _searchMode(showFilterRow, searchByColumnsStorageKey)
    setSearchByColumns(!searchMode)
    localStorage.setItem(searchByColumnsStorageKey, !searchMode)
    clearFilters()
    setSearchByColumnsLabel(searchMode ? 'Search By Columns' : ' Global Search')
    setShowGlobalFilter(searchByColumns)
    setShowHeaderFilter(!searchByColumns)
  }

  let permissions = null
  if (typeof editingOptions !== 'undefined' && editingOptions !== null && typeof editingOptions === 'object') {
    permissions = editingOptions.permissions
  }

  let isEditing = false
  let hasActionColumn = false

  if (!isObjectEmpty(urlCrudButtons)) {
    hasActionColumn = true
  } else if (editing === true) {
    isEditing = true
    hasActionColumn = !isEditing
  } else if (editing === false || isObjectEmpty(urlCrudButtons)) {
    isEditing = false
    hasActionColumn = false
  }

  const showColumnChooserFunction = () => {
    getDataGrid().showColumnChooser()
  }

  const getActionButtonsPermissions = () => {
    if (showActionButtons === true && actionButtons && actionButtons.length > 0) {
      const possiblePermissions = ['create', 'read', 'update', 'delete']
      const actionButtonsPermissions = []

      actionButtons.forEach((actionButton, index) => {
        if (!('permissions' in actionButton)) {
          return false
        }

        const parts = actionButton.permissions.split('.')
        const permissionEntity = parts[0]
        const buttonPermission = parts[1]
        let hasPermissionResult = false
        let permissionString = ''
        possiblePermissions.forEach(permission => {
          if (actionButton.hasPermission === false || !actionButton.hasPermission) {
            permissionString = `${permissionEntity.toUpperCase()}.${permission.toLowerCase()}`
            hasPermissionResult = hasPermission(permissionString)
            if (hasPermissionResult && permission.toLowerCase() === buttonPermission.toLowerCase()) {
              actionButton.hasPermission = true
            } else {
              actionButton.hasPermission = false
            }
            permissionString = ''
            hasPermissionResult = false
          }
        })
        actionButtonsPermissions.push(actionButton)
      })
      return actionButtonsPermissions
    }
  }

  const inLineRowButtonsPermissions = buttonsArray => {
    if (
      typeof buttonsArray !== 'undefined' &&
      buttonsArray !== null &&
      typeof editingOptions === 'object' &&
      !isObjectEmpty(editingOptions)
    ) {
      permissions = buttonsArray.permissions
    } else {
      return false
    }
    // If no permissions strings are given for inlineediting then no in line editing
    if (
      (!permissions && 'editingMode' in editingOptions.editingMode) ||
      (permissions !== undefined && Object.keys(permissions).length === 0)
    ) {
      return false
    }
    // If permissions are given, then check if they are allowed
    const createPermission = require('@components/general/Permissions.js').hasPermission(permissions.create)
    const updatePermission = require('@components/general/Permissions.js').hasPermission(permissions.update)
    const deletePermission = require('@components/general/Permissions.js').hasPermission(permissions.delete)

    if (permissions.create && createPermission) {
      buttonsArray.allowAdding = true
    } else {
      buttonsArray.allowAdding = false
    }

    if (permissions.update !== undefined && permissions.update && updatePermission) {
      buttonsArray.allowUpdating = true
    } else {
      buttonsArray.allowUpdating = false
    }
    if (permissions.delete && deletePermission) {
      buttonsArray.allowDeleting = true
    } else {
      buttonsArray.allowDeleting = false
    }
    return buttonsArray
  }

  const cellRenderUrlRowButtons = data => {
    if (isEditing === true) {
      return false
    }

    // let theseGridButtons = false
    // if (urlCrudButtons && (Array.isArray(urlCrudButtons) || urlCrudButtons.length === 0)) {
    //   theseGridButtons = urlCrudButtons
    // }

    if (urlCrudButtons) {
      const theseGridButtons = data.row.isEditing && editingUrlCrudButtons ? editingUrlCrudButtons : urlCrudButtons

      return (
        <div>
          {theseGridButtons.map((button, index) => {
            const alternativeDataKey = button.alternativeDataKey || null
            let dataKey = data.key
            if (alternativeDataKey) {
              dataKey = data.row.data[alternativeDataKey]
            }
            const conditionalField = button.conditionalField
            let condition = button.condition
            if (button.condition === undefined) {
              condition = null
            }

            const conditionalFieldArray = button.conditionalFieldArray || false
            const conditionalFieldValue = data['data'][conditionalField]
            const additionalProps = {}
            let buttonType = button.type || 'default'

            if (button.icon === 'trash' && !button.type) {
              buttonType = 'danger'
            }
            let disableButton = !!button.disabled
            if (conditionalField) {
              // if a condition is provided, check if met, otherwise disable according to field value
              if (condition && Array.isArray(condition) && condition.length === 2) {
                const [op, val] = condition
                const ops = {
                  '>': (a, b) => a > b,
                  '<': (a, b) => a < b,
                  '>=': (a, b) => a >= b,
                  '<=': (a, b) => a <= b,
                  '==': (a, b) => a === b,
                  '!=': (a, b) => a !== b
                }
                const check = ops[op]
                if (check) {
                  disableButton = !check(conditionalFieldValue, val)
                } else {
                  console.error('Invalid operator:', op)
                }
              } else if (!conditionalFieldArray) {
                disableButton = !conditionalFieldValue
              } else {
                const fieldArrayValue = data['data'][conditionalField]
                const containsFieldArrayValue = conditionalFieldArray.includes(fieldArrayValue)
                disableButton = !containsFieldArrayValue
              }
            }

            if (button.onClick) {
              additionalProps.onClick = () => onClickFunction(dataKey, button.onClick)
            }

            const urlSuffix = button.urlSuffix || null

            return button.visible ? (
              <ProtectedRouteNew
                dataKey={dataKey}
                disabled={disableButton}
                height={button.height || '25'}
                id={data.row.data.id}
                key={index}
                onButtonRender={createButtonInfo}
                protected_route={`${button.url}/${dataKey}${urlSuffix ? `/${urlSuffix}` : ''}`}
                stylingMode={button.stylingMode || 'outlined'}
                text={button.text}
                type={buttonType}
                width={button.height || '30'}
                {...button}
                {...additionalProps}
              />
            ) : null
          })}
        </div>
      )
    }
  }

  /**
   * downloadDataGrid
   *
   * This function is called when Export to Excel is clicked and the number of rows is less than 30K.
   *
   * @param {Event} e - Event object
   * @param {String} fileName - The name of the file
   * @returns {void}
   */
  const downloadDataGrid = (e, fileName) => {
    if (!titleNoSpace) {
      console.error('titleNoSpace is missing')
      return
    }
    const dataGrid = getDataGrid()
    const fileTabName = `${titleNoSpace}`
    const workbook = new Workbook()
    const worksheet = workbook.addWorksheet(fileTabName)

    exportDataGrid({
      component: dataGrid,
      worksheet,
      autoFilterEnabled: true
    }).then(() => {
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName)
      })
    })
    e.cancel = true
  }

  /**
   * emailExport
   *
   * This function is called when the user clicks on the "Export to Excel" button and the rows are more than 30K.
   *
   * @param {Array} columns - The columns to export
   * @param {String} fileName - The name of the file
   * @param {Number} $top - The number of rows to export
   * @param {String} gridTitle - The title of the grid
   * @returns {Promise<void}
   */
  const emailExport = useCallback(
    (columns, fileName, $top, gridTitle) => {
      return brandit_rails
        .post(
          `${gridUrl.replace('/mf/grid', '/mf/grid/export')}`,
          {
            columns: hasActionColumn ? columns.slice(0, -1) : columns
          },
          {
            params: {
              ...urlParams.current,
              file_name: fileName,
              grid_title: gridTitle,
              $top,
              $skip: 0,
              permissions: gridConfig.permissions
            }
          }
        )
        .then(() => {
          dispatch(
            dispatchSweetAlert({
              title: 'Exporting',
              alertMessage: 'The export is being processed. You will receive an email with the excel file.',
              showCancel: false,
              confirmBtnText: 'OK',
              onConfirm: () => {}
            })
          )
        })
        .catch(() => {
          dispatch(
            dispatchSweetAlert({
              type: 'error',
              title: 'Error',
              alertMessage: 'There was an error generating the export file. Please try again.',
              onConfirm: () => {}
            })
          )
        })
    },
    [gridUrl, hasActionColumn, gridConfig.permissions, dispatch]
  )

  /**
   * onExportingClick
   *
   * This function is called when the user clicks on the "Export to Excel" button.
   *
   * It downloads all the results. If the number of rows is greater than 30,000, it will send an email with the file.
   * Also there is a limit of 1M rows for the export file.
   *
   * @param {Event} e - Event object
   * @returns {void}
   */
  const onExportingClick = e => {
    if (!titleNoSpace) {
      console.error('titleNoSpace is missing')
      return
    }
    const dataGrid = getDataGrid()
    const date = new Date()
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    const gridTitle = titleNoSpace
    const fileName = `${titleNoSpace}_${year}-${month}-${day}_${hours}_${minutes}_${seconds}.xlsx`
    const columns = dataGrid
      .getVisibleColumns()
      .map(column => ({ dataField: column.dataField, caption: column.caption }))
    const totalRowCount = dataGrid.totalCount()

    if (totalRowCount > 1000000000) {
      dispatch(
        dispatchSweetAlert({
          type: 'error',
          title: 'File Size Limit Exceeded',
          alertMessage: 'The export file size limit is 1M rows. Please apply filters to reduce the number of rows.',
          onConfirm: () => {}
        })
      )
      return
    }
    /**
     * If the number of rows is greater than 30,000, it will send an email with the file.
     */
    if (totalRowCount > 30000) {
      emailExport(columns, fileName, totalRowCount, gridTitle)
    } else {
      downloadDataGrid(e, fileName)
    }
    e.cancel = true
  }

  const customCellExport = (data, tags) => {
    // SN_QUESTION: ['order_created_at', 'shipping_date']
    const dateFields = ['order_created_at', 'shipping_date']
    const { gridCell, excelCell } = data
    const columnName = gridCell.column.name
    if (dateFields.includes(columnName) && gridCell.rowType !== 'header') {
      const newDate = renderDate(gridCell)
      excelCell.value = newDate
    } else if (columnName === 'tag_array' && gridCell.rowType !== 'header') {
      const tagsAsString = renderTags(gridCell, tags, true)
      excelCell.value = tagsAsString
    }
  }

  const contextMenuitemClick = protectedRoute => {
    window.open(protectedRoute, '_blank')
  }

  window.onSelectionChanged = function (data) {
    if (props.eventsConfig.onSelectionChanged) {
      props.eventsConfig.onSelectionChanged(data)
    }
  }

  const onClickExtraButton01 = data => {
    if (props.eventsConfig.onClickExtraButton01) {
      props.eventsConfig.onClickExtraButton01(data)
    }
  }
  window.onClickExtraButton01 = function (data) {
    // window... is necessary to have the function to be executed by name from onClickFunction
    if (onClickExtraButton01) {
      onClickExtraButton01(data)
    }
  }

  const onClickExtraButton02 = data => {
    if (props.eventsConfig.onClickExtraButton02) {
      props.eventsConfig.onClickExtraButton02(data)
    }
  }
  window.onClickExtraButton02 = function (data) {
    if (onClickExtraButton02) {
      onClickExtraButton02(data)
    }
  }

  const onClickExtraButton03 = data => {
    if (props.eventsConfig.onClickExtraButton03) {
      props.eventsConfig.onClickExtraButton03(data)
    }
  }

  window.onClickExtraButton03 = function (data) {
    if (onClickExtraButton03) {
      onClickExtraButton03(data)
    }
  }

  const onClickExtraButton04 = data => {
    if (props.eventsConfig.onClickExtraButton04) {
      props.eventsConfig.onClickExtraButton04(data)
    }
  }

  window.onClickExtraButton04 = function (data) {
    if (onClickExtraButton04) {
      onClickExtraButton04(data)
    }
  }

  const onClickExtraButton05 = data => {
    if (props.eventsConfig.onClickExtraButton05) {
      props.eventsConfig.onClickExtraButton05(data)
    }
  }

  window.onClickExtraButton05 = function (data) {
    if (onClickExtraButton05) {
      onClickExtraButton05(data)
    }
  }

  const onActionButtonAnyItemClick = data => {
    if (props.eventsConfig.onActionButtonAnyItemClick) {
      props.eventsConfig.onActionButtonAnyItemClick(data, props.history)
    }
  }

  window.onActionButtonAnyItemClick = function (data) {
    if (onActionButtonAnyItemClick) {
      onActionButtonAnyItemClick(data, props.history)
    }
  }

  const onActionButtonFirstItemClick = data => {
    props.eventsConfig.onActionButtonFirstItemClick(firstButtonConfig)
  }

  window.onActionButtonFirstItemClick = function (data) {
    if (onActionButtonFirstItemClick) {
      onActionButtonFirstItemClick(data)
    }
  }

  // const onActionButtonFirstItemClick = data => {
  //   props.eventsConfig.onActionButtonFirstItemClick(data)
  // }

  // window.onActionButtonFirstItemClick = function (data) {
  //   if (onActionButtonFirstItemClick) {
  //     onActionButtonFirstItemClick(data)
  //   }
  // }

  const onClickFunction = (data, functionName) => {
    let functionToCall
    if (typeof functionName === 'string' && functionName.trim() !== '') {
      functionToCall = window[functionName]
      if (typeof functionToCall === 'function') {
        functionToCall(data)
      } else {
        console.error(`${functionName} is not a valid function (1)`)
      }
    } else {
      console.error(`${functionName} is not a valid function (2)`)
    }
  }

  const mode = 'select'
  const selectByClick = true
  const recursive = true
  const searchEditorOptions = { placeholder: 'Search column' }
  const columnChooserModeLabel = { 'aria-label': 'Column Chooser Mode' }
  const allowSelectAll = true

  const newSearchBoxWidth = useMemo(() => {
    let gridsPerRow = 1
    if (searchPanel.gridsPerRow) {
      gridsPerRow = searchPanel.gridsPerRow
    }
    if (isDesktop) return Math.round(Math.round(window.innerWidth / 4, 0) / gridsPerRow)
    if (isLargeDesktop) return Math.round(Math.round(window.innerWidth / 10, 0) / gridsPerRow)

    // if (isDesktop) {
    //   return Math.round(Math.round(window.innerWidth / 4, 0) / gridsPerRow)
    // } else if (isLargeDesktop) {
    //   return Math.round(Math.round(window.innerWidth / 10, 0) / gridsPerRow)
    // } else if (isSmallWindow) {
    //   return Math.round(Math.round(window.innerWidth / 1.5, 0) / gridsPerRow)
    // } else {
    //   return Math.round(Math.round(window.innerWidth / 1.2, 0) / gridsPerRow)
    // }

    // return Math.round(Math.round(window.innerWidth / 4, 0) / gridsPerRow)
  }, [isLargeDesktop, isDesktop])

  const [searchBoxWidth, setSearchBoxWidth] = useState(200) // Start with a more reasonable default

  // useEffect(() => {
  //   // dynamically calculates  the size of the search box
  //   const calculateSearchBoxWidth = () => {
  //     // Get references to the elements
  //     const headerPanel = document.querySelector('.dx-datagrid-header-panel')
  //     if (!headerPanel) {
  //       return
  //     }

  //     // Find toolbar sections
  //     const toolbarBefore = headerPanel.querySelector('.dx-toolbar-before')
  //     const toolbarCenter = headerPanel.querySelector('.dx-toolbar-center')
  //     const toolbarAfter = headerPanel.querySelector('.dx-toolbar-after')

  //     if (!toolbarBefore) {
  //       return
  //     }

  //     // Find search box in the "before" section
  //     const searchBox = toolbarBefore.querySelector('.dx-texteditor-input[aria-label="Search in the data grid"]')
  //     if (!searchBox) {
  //       return
  //     }

  //     const searchBoxContainer = searchBox.closest('.dx-textbox')
  //     if (!searchBoxContainer) {
  //       return
  //     }

  //     // Calculate widths
  //     const headerPanelWidth = headerPanel.offsetWidth
  //     const toolbarCenterWidth = toolbarCenter ? toolbarCenter.offsetWidth : 0
  //     const toolbarAfterWidth = toolbarAfter ? toolbarAfter.offsetWidth : 0

  //     // Add some additional buffer for potential padding/margins
  //     const additionalBuffer = 60

  //     // Calculate space needed for center and after sections
  //     const rightSectionsWidth = toolbarCenterWidth + toolbarAfterWidth + additionalBuffer

  //     // Calculate available width for search box (make sure it's at least 150px)
  //     // We need to make this smaller to ensure it doesn't overlap other elements
  //     const maxWidthPercent = 0.4 // 40% of header panel width maximum
  //     const maxWidth = headerPanelWidth * maxWidthPercent
  //     const availableWidth = Math.max(50, Math.min(maxWidth, headerPanelWidth - rightSectionsWidth - additionalBuffer))

  //     //   headerPanelWidth,
  //     //   toolbarCenterWidth,
  //     //   toolbarAfterWidth,
  //     //   rightSectionsWidth,
  //     //   availableWidth
  //     // })
  //     // Update the search box width if it changed significantly (prevent small fluctuations)
  //     if (Math.abs(availableWidth - searchBoxWidth) > 5) {
  //       setSearchBoxWidth(availableWidth)

  //       // Apply the change directly to the grid component for immediate effect
  //       if (gridRef.current && gridRef.current.instance) {
  //         gridRef.current.instance.option('searchPanel.width', availableWidth)
  //       }
  //     }
  //   }

  //   // Run initial calculation after components are fully rendered
  //   const initialTimer = setTimeout(calculateSearchBoxWidth, 500)

  //   // Add event listener for window resize with debounce
  //   let resizeTimer
  //   const handleResize = () => {
  //     clearTimeout(resizeTimer)
  //     resizeTimer = setTimeout(calculateSearchBoxWidth, 100) // Debounce resize events
  //   }

  //   window.addEventListener('resize', handleResize)

  //   // Clean up
  //   return () => {
  //     clearTimeout(initialTimer)
  //     clearTimeout(resizeTimer)
  //     window.removeEventListener('resize', handleResize)
  //   }
  // }, []) // Remove searchBoxWidth from dependencies to prevent unnecessary recalculations

  const onEditorPreparing = e => {
    if (e.parentType === 'dataRow') {
      // Highlight the editable cells when on inline editing mode
      // except if it's a selection column
      if (e.readOnly !== true && e.type !== 'selection' && e.fixed === true) {
        e.editorElement.style.border = '1px solid'
        e.editorElement.style.borderColor = '#03a1dd'
      }
      if (props.eventsConfig.onEditorPreparing) {
        props.eventsConfig.onEditorPreparing(e)
      }
    }
  }

  const onRowClick = data => {}

  // const onDataRowRender = data => {
  //   if (props.eventsConfig.onDataRowRender) {
  //     props.eventsConfig.onDataRowRender(data)
  //   }
  // }

  const onCellPrepared = e => {
    // highlight the editable cells when on inline batch editing mode
    const allowEditing = e.column.allowEditing && isEditing
    if (allowEditing === true && e.rowType === 'data' && editingOptions.editingMode === 'batch') {
      e.cellElement.classList.add('column-highlight')
    }
  }

  const onRowPrepared = e => {
    if (rowHeight) {
      e.rowElement.style.height = rowHeight
    }
    if (props.eventsConfig.onRowPrepared) {
      props.eventsConfig.onRowPrepared(e)
    }
  }

  // const renderEditableToolTip = () => {
  //   return <p>Click any highligted fields to edit it.</p>
  // }

  // const onAdd = data => {
  //   //onRowDragging.OnAdd
  //   if (props.eventsConfig.onRowDragging.OnAdd) {
  //     props.eventsConfig.onRowDragging.OnAdd(data)
  //   }
  // }

  if (!gridUrl) {
    return <div>Invalid parameters. Please contact the support team.</div>
  }

  const ActionButtonsPermissionsResult = getActionButtonsPermissions()
  const filteredActionButtons = ActionButtonsPermissionsResult
    ? ActionButtonsPermissionsResult.filter((actionButton, index) => {
        return index !== 0 && actionButton.hasPermission === true
      })
    : []
  let firstButtonText = ''

  if (actionButtons && actionButtons.length > 0 && actionButtons[0].hasPermission === true) {
    firstButtonText = actionButtons[0].text
  }

  const displaySelectedRowsKey = selectedRowKeys => {
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      return ` Row${selectedRowKeys.length > 1 ? 's' : ''} selected: ${selectedRowKeys.length}`
    }
    return <div>&nbsp;</div>
  }

  const shouldShowInlineUpdateDeleteButtons = () => {
    const allowInLineUpdatingPermission = inLineRowButtonsPermissions(editingOptions).allowUpdating
    if (isEditing === true) {
      return true
    } else if (
      (allowInLineUpdatingPermission === true && actionButtonsMode === 'createButtonOnly') ||
      isEditing === false
    ) {
      return false
    }
    return true
  }

  // const onToolbarPreparing = e => {
  //   // setSearchBoxWidth(newSearchBoxWidth)
  //   ATTENTION: NULTILINE OVERWRITES THE TOOLBAR POSITIONING SYSTEM
  //   // e.toolbarOptions.multiline = true
  //   ATTENTION: NULTILINE OVERWRITES THE TOOLBAR POSITIONING SYSTEM
  // }

  // const renderNoGroupButtonsFilter = () => {
  //   return filterButtons.buttons.map((button, index) => (
  //     <div key={index}>
  //       <MfButton component="dx" icon={button.icon} text={button.text} type={button.type} visible={button.visible} />
  //     </div>
  //   ))
  // }

  // shouldShowInlineUpdateDeleteButtons()

  /* ************************************ */
  /* FORM HANDLING -- EX: ARTWORK FIELDS
  /* ************************************ */

  // const saveChange = c => {
  //   getDataGrid.saveEditData()
  // }

  // const hideEditForm = e => {
  //   // if event comes from the popup, check the form for validity
  //   if (e && e.component && e.component.NAME === 'dxPopup') {
  //     // if error, don't hide form
  //     if (props.error) {
  //       e.cancel = true
  //       toastr.error(props.error)
  //       return
  //     }
  //   } else {
  //     setEditFormVisible(false)
  //     setFormCurrentRecord({})
  //     props.clearMfError()
  //   }
  // }

  // const handleError = error => {
  //   const tableTitle = titleToSnakeCase(this.props.title)
  //   toastr.error(error.error.message, { timeOut: 8000 })
  //   if (error.error.errorDetails) {
  //     this.props.setMfError(`form_${tableTitle}_${error.error.errorDetails.record_id}`, error.error.message)
  //   }
  // }

  // const showEditForm = record => {
  //   setFormCurrentRecord({ record })
  //   setEditFormVisible(true)
  // }

  // const saveChanges = c => {
  //   // getDataGrid.saveEditData()
  // }

  // const forceCloseEditForm = () => {
  //   props.clearMfError()
  //   setEditFormVisible(false)
  //   setFormCurrentRecord({})
  // }

  // const setFormWidth = e => {
  //   e.element.style.width = '500px'
  //   e.element.title = '500px'
  // }

  /* ************************************ */
  /* END FORM HANDLING -- EX: ARTWORK FIELDS
  /* ************************************ */

  /* *************** */
  /* RENDER GRID */
  /* *************** */
  if (isValid === false) {
    return (
      <div>
        <div>{actionButtonsMode}</div>
        <br></br>
        <div className="alert alert-primary">
          <b>{actionButtonDevMessage}</b>
        </div>
      </div>
    )
  } else {
    return (
      <div>
        <div className="selected-row-display">{displaySelectedRowsKey(selectedRowKeys)}</div>
        <DataGrid
          allowColumnReordering={allowColumnReordering || true}
          allowColumnResizing={allowColumnResizing || true}
          allowSorting={allowSorting || true}
          columnAutoWidth={columnAutoWidth || true}
          columnHidingEnabled={columnHidingEnabled || false}
          // dataRowRender={onDataRowRender}
          dataRowRender={props.eventsConfig.onDataRowRender || null}
          dataSource={dataSourceOptions}
          hoverStateEnabled={hoverStateEnabled}
          // id={storageKey}
          id="grid"
          // id={isSearchResponsive ? 'grid' : storageKey} // for future use
          key={storageKey}
          noDataText={noDataText}
          onCellPrepared={onCellPrepared}
          onEditorPreparing={onEditorPreparing}
          onInitNewRow={props.eventsConfig.onInitNewRow}
          onRowDragging={props.eventsConfig.onRowDragging}
          onRowClick={onRowClick}
          onRowPrepared={onRowPrepared}
          onRowRemoving={props.eventsConfig.onRowRemoving}
          onSaving={props.eventsConfig.onSaving}
          onEditingStart={props.eventsConfig.onEditingStart}
          onEditCanceled={props.eventsConfig.onEditCanceled}
          onSelectionChanged={onSelectionChanged}
          // onToolbarPreparing={onToolbarPreparing}
          ref={gridRef}
          rowAlternationEnabled={rowAlternationEnabled || true}
          selectedRowKeys={selectedRowKeys}
          showBorders={showBorders || true}
          tableViewName={getTableViewName}
          height={!hasData ? (searchByColumns ? '30.5rem' : '25rem') : '100%'}
          onOptionChanged={handleOptionChanged}
          onContextMenuPreparing={e => {
            if (
              e.row &&
              e.row.rowType &&
              e.row.rowType === 'data' &&
              showRowContextMenu === true &&
              isEditing === false
            ) {
              const menuItems = [
                {
                  text: `New Tab Actions ${showIds && showIds === true ? e.row.data.id : ''}`
                }
              ]

              // Access the specific array of buttons for this ID
              const buttonsForId = renderedButtonsRef.current[e.row.data.id]
              // Ensure there are buttons to process for this ID
              if (buttonsForId && buttonsForId.length > 0) {
                // Iterate over each button and build the menu item
                buttonsForId.forEach(buttonInfo => {
                  let disableButtonInfo = buttonInfo.disabled
                  if (buttonInfo.protectRoute === null) {
                    disableButtonInfo = true
                  }
                  const item = {
                    text: ` ${buttonInfo.name}`,
                    icon: buttonInfo.icon,
                    disabled: disableButtonInfo,
                    onItemClick() {
                      contextMenuitemClick(buttonInfo.protectRoute)
                    }
                  }
                  menuItems.push(item)
                })
              }
              e.items = menuItems
            }
          }}
          {...props}
        >
          {!hasData && hasInitialData && Object.values(filtersStatus).includes(true) && (
            <div className="devex-grid-nodata-container">
              <div className="devex-grid-nodata-container-copy">
                <span>It looks like there are no results due to the current filters applied.</span>
                <span>
                  Please review your filter settings or click the button below to clear all filters and try again.
                </span>
              </div>
              <MfButton
                component="dx"
                type="default"
                stylingMode="contained"
                text="Clear Filters"
                onClick={clearFilters}
              />
            </div>
          )}
          <LoadPanel
            enabled
            // height={100}
            // width={250}
            // indicatorSrc="https://js.devexpress.com/Content/data/loadingIcons/rolling.svg"
          />
          {columns.map((col, index) => (
            <Column key={index} {...col} />
          ))}

          {pager.visible ? <Pager {...pager} /> : null}
          {pager.visible === false ? null : <Paging defaultPageSize={10} />}
          <SearchPanel
            enterToSearch={true}
            milliSecondsToSearchIfNoEnter={1000}
            placeholder={searchPanel.placeHolder}
            visible={showGlobalFilter}
            width={searchPanel.width ?? searchBoxWidth}
            // width={searchPanel.width}
            // width={!isSearchResponsive ? searchPanel.width : null}
          />
          <ColumnFixing texts={fixingTexts} enabled={true} />
          <ColumnChooser enabled={showColumnChooser} mode={mode} width={400}>
            <Position my="left center" at="center center" of={ellipsisId} />
            <ColumnChooserSearch editorOptions={searchEditorOptions} enabled={true} />
            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          {/* {props.onRowDragging && props.onRowDragging.enabled ? (
            <RowDragging
              data={status}
              group={storageKey}
              onAdd={onAdd}
            />
          ) : null} */}

          <Toolbar>
            <Item location="before" name="searchPanel" visible={searchPanel.visible}></Item>
            {/* htt`ps://js.devexpress.com/React/Demos/WidgetsGallery/Demo/DataGrid/ToolbarCustomization/Light/ */}
            <Item location="center">
              {!isObjectEmpty(filterButtons) && !isFilterButtonsStackable ? (
                <ButtonGroup
                  id="idFilters"
                  activeStateEnabled={true}
                  items={processedButtonFilters && processedButtonFilters.length > 0 ? processedButtonFilters : []}
                  keyExpr="text"
                  onItemClick={onClickButtonFilter}
                  selectedItemKeys={filterButtons.props.selectedItemKeys}
                  stylingMode={filterButtons.props.stylingMode || 'outlined'}
                  visible={filterButtons.props.visible}
                />
              ) : null}
              {/* {renderNoGroupButtonsFilter()} */}
              {!isObjectEmpty(filterButtons) && isFilterButtonsStackable & (isFilterButtonsStackable === true)
                ? filterButtons.buttons.map((button, index) => (
                    <MfButton
                      component="dx"
                      style={{
                        fontSize: '14px',
                        fontWeight: '900'
                        // width: '110px',
                        // height: '20px',
                        // paddingTop: '2px!important',
                        // paddingLeft: '2px!important',
                        // paddingRight: '2px!important',
                        // paddingBottom: '2px!important',
                        // margin: '0px',
                      }}
                      key={index}
                      icon={button.icon}
                      onClick={onClickButtonFilter}
                      stylingMode={button.stylingMode || 'outlined'}
                      text={button.text}
                      type={button.type}
                      visible={button.visible}
                    />
                  ))
                : null}
            </Item>
            <Item name="saveButton" location="after" />
            <Item name="revertButton" location="after" />
            {/* // this is the add button when alone */}
            <Item location="after">
              {firstButtonConfig && showFirstButton && showFirstButtonOnly ? (
                createButton.mode === 'row' ? (
                  <ProtectedRouteNew
                    {...firstButtonConfig}
                    className="devex-button-bold-text"
                    protected_route={`${createButton.url}`}
                  />
                ) : (
                  <ProtectedRouteNew
                    className="devex-button-bold-text"
                    {...firstButtonConfig}
                    onClick={onActionButtonFirstItemClick}
                  ></ProtectedRouteNew>
                )
              ) : null}
            </Item>

            {/* ACTION MENU - -Ellipis */}
            <Item>
              {showFirstButtonOnly === false && showActionButtons ? (
                <DropDownButton
                  displayExpr="text"
                  id="actionButtons"
                  items={filteredActionButtons}
                  key={`ddBtn_${titleNoSpace}`}
                  keyExpr="id"
                  onButtonClick={onActionButtonFirstItemClick}
                  onItemClick={onActionButtonAnyItemClick}
                  splitButton={true}
                  text={firstButtonText}
                  useSelectMode={false}
                  width={buttonsWidth}
                />
              ) : null}
            </Item>
            {/* OPTION MENU - -Ellipis */}
            <Item location="after">
              <DropDownButton
                id={ellipsisId}
                displayExpr="text"
                dropDownOptions={{ width: '200px' }}
                icon="fa-solid fa-ellipsis-vertical"
                items={showOnlyClearAndExportBtns ? optionButtonsShowOnlyClearAndExport() : optionButtons()}
                showArrowIcon={false}
                type="success"
              />
            </Item>
          </Toolbar>

          <FilterRow visible={searchByColumns} />
          {showHeaderFilter ? (
            <HeaderFilter {...headerFilter} visible={showHeaderFilter}>
              {headerFilter.showSearch && headerFilter.showSearch.enabled === true ? (
                <Search {...headerFilter.showSearch} />
              ) : null}
            </HeaderFilter>
          ) : null}
          <MasterDetail
            autoExpandAll={
              masterDetailConfig.enabled && masterDetailConfig.autoExpandAll ? masterDetailConfig.autoExpandAll : false
            }
            enabled={masterDetailConfig.enabled}
            component={
              masterDetailConfig.enabled && masterDetailConfig.component && masterDetailConfig.component
                ? masterDetailConfig.component
                : false
            }
          />
          <Selection mode={rowSelectionMode} selectAllMode={selectAllMode} showCheckBoxesMode={showCheckBoxesMode} />
          {hasActionColumn === true ? (
            <Column
              allowEditing={false}
              allowSorting={false}
              caption="Actions"
              cellRender={cellRenderUrlRowButtons}
              cssClass={actionColumnClass || ''}
              dataType="boolean" // used to center align the column
              fixed={actionColumnFixed || true}
              fixedPosition="right"
              key="action_buttons_column"
              name="CustomRenderShow"
              showInColumnChooser={false}
              width={actionColumnWidth || 125}
            />
          ) : null}

          <StateStoring enabled={true} type="localstorage" storageKey={storageKey} />

          {(!!inLineRowButtonsPermissions(editingOptions).allowUpdating ||
            !!inLineRowButtonsPermissions(editingOptions).allowDeleting) &&
            (isEditing === true || showCreateButton) && (
              <Editing
                allowAdding={!!inLineRowButtonsPermissions(editingOptions).allowAdding}
                allowDeleting={shouldShowInlineUpdateDeleteButtons && !hideDeleteButton}
                allowUpdating={shouldShowInlineUpdateDeleteButtons}
                mode={inLineRowButtonsPermissions(editingOptions).editingMode || 'row'} // options are popup, row, batch or form
                refreshMode={false}
                selectTextOnEditStart={true}
                showEditorAlways={false}
                texts={{
                  confirmDeleteMessage:
                    editingOptions.confirmDeleteMessage || 'Are you sure you want to delete this record?',
                  confirmDeleteTitle: editingOptions.confirmDeleteTitle || 'Delete Confirmation',
                  editRow: editingOptions.editRowText,
                  deleteRow: editingOptions.deleteRowText
                }}
                useIcons={editingOptions.useIcons || true}
                // popup={{
                //   visible: editFormVisible,
                //   onHiding: hideEditForm,
                //   toolbarItems: [
                //     {
                //       widget: 'dxButton',
                //       visible: editingOptions.formButtons.saveVisible,
                //       location: 'after',
                //       toolbar: 'bottom',
                //       options: {
                //         text: editingOptions.formButtons.saveText || 'Save',
                //         type: 'success',
                //         onClick: saveChanges,
                //       },
                //     },
                //     {
                //       widget: 'dxButton',
                //       visible: editingOptions.formButtons.cancelVisible,
                //       location: 'after',
                //       toolbar: 'bottom',
                //       options: {
                //         text: editingOptions.formButtons.cancelText || 'Cancel',
                //         onClick: forceCloseEditForm,
                //       },
                //     },
                //     {
                //       widget: 'dxButton',
                //       visible: editingOptions.formButtons.closeVisible,
                //       location: 'after',
                //       toolbar: 'bottom',
                //       options: {
                //         type: 'danger',
                //         text: editingOptions.formButtons.closeText || 'Close',
                //         onClick: forceCloseEditForm,
                //       },
                //     },
                //   ],
                // }}
              >
                {/* <Texts
                    <<<<< NO NEED AS IT IS ALREADY IN THE EDITING COMPONENT >>>>
                      editRow={editingOptions.editRowText}
                      confirmDeleteMessage="Are you sure you want to delete this record?"
                      confirmDeleteTitle="Delete Confirmation"
                    /> */}
                {/* <Popup
                      title="Edit Artwork Field"
                      showTitle={true}
                      visible={editFormVisible}
                      title={popup.title}
                      showTitle={popup.showTitle}
                      visible={editFormVisible}
                    /> */}
                <Form
                  className="class-name"
                  // id="elementId"
                  // elementAttr={{
                  //   id: 'elementId',
                  //   class: 'class-name',
                  // }}
                  // onInitialized={setFormWidth}
                  // onContentReady={setFormWidth}
                  // width='50%'
                >
                  {Object.entries(_.groupBy(columns, 'formGroup')).map(([groupName, cols]) => {
                    return (
                      <Item
                        caption={groupName === 'undefined' ? 'General' : groupName}
                        itemType="group"
                        key={groupName}
                        width={'90%'}
                      >
                        {cols &&
                          cols.map((col, i) => {
                            return (
                              <Item
                                key={i}
                                dataField={col.dataField}
                                editorOptions={col.notesEditorOptions}
                                editorType={col.editorType}
                                helpText={col.tooltip}
                                isRequired={col.isRequired}
                              />
                            )
                          })}
                      </Item>
                    )
                  })}
                </Form>
              </Editing>
            )}
        </DataGrid>
        {/* <Tooltip
          target=".column-highlight"
          showEvent="dxhoverstart"
          hideEvent="dxhoverend"
          contentRender={renderEditableToolTip}
          maxHeight={50}
        /> */}
      </div>
    )
  }
}

MfGridFunctional.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      dataField: PropTypes.string,
      dataType: PropTypes.string
    })
  ),
  dataKey: PropTypes.string,
  gridUrl: PropTypes.string,
  urlCrudButtons: PropTypes.arrayOf(PropTypes.object),
  editingUrlCrudButtons: PropTypes.arrayOf(PropTypes.object)
}
export default withRouter(MfGridFunctional)
